import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { getUserId } from "services/storage/general";
import { parseToChangeHistoryItem } from "./helpers";

export const requestGetSpacesByCampus = async campusId => {
    const [result, err] = await doRequest(
        `/Polideportivo/LeerEspaciosPorCampus/${campusId}`, "GET",
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    return data.data.espacios.map(({
        idPolideportivo, nombre, activo
    }) => ({
        id: idPolideportivo,
        name: nombre,
        active: activo
    }));
}
export const requestGetSpaceById = async spaceId => {
    const [result, err] = await doRequest(
        `/Polideportivo/LeerPolideportivoPorId/${spaceId}`, "GET",
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    const {
        idPolideportivo, nombre, idCampus,
        idTipoEspacioPolideportivo,
        deporteIds, aforoMin, aforoMax,
        direccion, referencia, fueraCampus,
        detalles, activo
    } = data.data.polideportivo;
    return {
        id: idPolideportivo, campusId: idCampus,
        spaceTypeId: idTipoEspacioPolideportivo,
        name: nombre, availableActivityIds: deporteIds,
        minCapacity: String(aforoMin), maxCapacity: String(aforoMax),
        address: direccion || "", reference: referencia,
        spaceOutOfCampus: fueraCampus,
        details: detalles || "", active: activo
    };
}
export const requestCreateSpace = async ({
    campusId, spaceTypeId, name,
    availableActivityIds, minCapacity,
    maxCapacity, address, reference,
    spaceOutOfCampus, details
}) => {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/Crear", "POST",
        {
            idCampus: campusId,
            idTipoEspacio: spaceTypeId,
            nombre: name,
            idsActividades: availableActivityIds,
            aforoMin: minCapacity,
            aforoMax: maxCapacity,
            direccion: address ? address : null,
            referencia: reference, fueraCampus: spaceOutOfCampus,
            detalles: details ? details : null,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    return {
        success: data.data.exito,
        message: null
    };
}
export const requestUpdateSpaceById = async ({
    id, name, availableActivityIds,
    minCapacity, maxCapacity, address,
    reference, spaceOutOfCampus, details
}) => {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/Editar", "POST",
        {
            idEspacioUniversitario: id,
            nombre: name,
            idsActividades: availableActivityIds,
            aforoMin: minCapacity,
            aforoMax: maxCapacity,
            direccion: address ? address : null,
            referencia: reference, fueraCampus: spaceOutOfCampus,
            detalles: details ? details : null,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    const { exito, mensaje } = data.data;
    // ERRORES POSIBLES: RESERVAS_FUTURAS
    return {
        message: mensaje,
        success: exito
    };
}
export const requestToggleActiveStateSpace = async ({
    spaceId, active
}) => {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/EditarActivo", "POST",
        {
            idEspacioUniversitario: spaceId,
            activar: active,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return {
            success: false,
            message: null
        };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return {
            success: false,
            message: null
        };
    const { exito, mensaje } = data.data;
    // ERRORES POSIBLES: RESERVAS_FUTURAS
    return {
        message: mensaje,
        success: exito
    };
}
export const requestDeleteSpaceById = async spaceId => {
    const [result, err] = await doRequest(
        "/EspacioUniversitario/Eliminar", "POST",
        {
            idEspacioUniversitario: spaceId,
            codigoUsuario: getUserId()
        }, getToken());
    if (err)
        return {
            success: false,
            message: null
        };
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return {
            success: false,
            message: null
        };
    const { exito, mensaje } = data.data;
    // ERRORES POSIBLES: RESERVAS_FUTURAS
    return {
        message: mensaje,
        success: exito
    };
}
export const requestGetChangeHistorySpace = async spaceId => {
    const [result, err] = await doRequest(
        `/EspacioUniversitario/Historial/${spaceId}`, "GET",
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.map(parseToChangeHistoryItem);
}